import { GraphSchema } from '@ta/server';

import { Estate } from '../../estates/dto/estate';
import { User } from '../../users/dto/user';
import { Company } from './company';
import { EstateManager } from './estate-manager';

export enum ECompanyRole {
  Employee = 0,
  Admin = 1,
}

export interface CompanyMember {
  id: string;
  companyId: string;
  userId: string;
  role: ECompanyRole;
  createdDate: string;
  updatedDate: string;
  deleted: boolean;
  company?: Company;
  user?: User;
  managedEstates?: EstateManager[];
  estates?: Estate[];
}

export const companyMemberBrutProps: (keyof CompanyMember)[] = [
  'id',
  'companyId',
  'userId',
  'role',
  'createdDate',
  'updatedDate',
  'company',
  'user',
  'managedEstates',
  'estates',
];

export const companyMemberProps = new GraphSchema<CompanyMember>(companyMemberBrutProps);
